import { render } from "./OrganizationEditPopup.vue?vue&type=template&id=651a1085&scoped=true"
import script from "./OrganizationEditPopup.vue?vue&type=script&lang=js"
export * from "./OrganizationEditPopup.vue?vue&type=script&lang=js"

import "./OrganizationEditPopup.vue?vue&type=style&index=0&id=651a1085&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651a1085"]])

export default __exports__